<!-- eslint-disable vue/valid-template-root -->
<template>
  <!-- Renderless component -->
</template>
<!-- eslint-enable vue/valid-template-root -->

<script setup lang="ts">
import { computed, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import i18n from '@/i18n'

import type { SidebarConfig } from '../types'

const emit = defineEmits<{
  'update:config': [config: SidebarConfig]
}>()

const router = useRouter()
const route = useRoute()

const isCurrent = (name: string) => {
  return route.name?.toString().startsWith(name)
}

const handleSubnavItemClick = (navItem: string, subnavItem: string) => {
  if (navItem === 'coaching') {
    if (subnavItem === 'sessions') {
      router.push({ name: 'coaching.sessions' })
    }
    if (subnavItem === 'pins') {
      router.push({ name: 'pins' })
    }
    if (subnavItem === 'quizzes') {
      router.push({ name: 'quizzes' })
    }
  }
}

const items = computed(() => [
  {
    children: i18n.t('routes.coaching.label.sessions'),
    key: 'sessions',
    isCurrent: isCurrent('coaching.session'),
    view: 'coaching',
  },
  {
    children: i18n.t('routes.coaching.label.pins'),
    key: 'pins',
    isCurrent: isCurrent('pins'),
    view: 'coaching',
  },
  {
    children: i18n.t('routes.coaching.label.quizzes'),
    key: 'quizzes',
    isCurrent: isCurrent('quizzes'),
    view: 'coaching',
  },
])

const config = computed(
  (): SidebarConfig => ({
    action: {
      tooltip: '',
      menuItems: [],
      onClick: () => {
        /* no-op */
      },
    },
    title: i18n.t('routes.coaching.type'),
    items: items.value,
    handleSubnavItemClick,
    handleSubnavItemActionClick: () => {
      /* no-op */
    },
    handleGroupActionClick: () => {
      /* no-op */
    },
  }),
)

// Emit initial config and watch for changes
onMounted(() => {
  emit('update:config', config.value)
})

// Watch for changes and emit updates
watch(config, (newConfig) => {
  emit('update:config', newConfig)
})
</script>
